module.exports = __webpack_public_path__ + "img/sprinkle-1.e34d51aa.jpg";